import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, TitleHeader } from 'web-library';
import ResitPaymentLink from '../../modules/financial/components/ResitPaymentLink';
import ExamRegistrationPaymentLink from '../../modules/financial/components/ExamRegistrationPaymentLink';
import AmendmentPaymentLink from '../../modules/financial/components/AmendmentPaymentLink';
import AppealPaymentLink from '../../modules/financial/components/AppealPaymentLink';

interface ExamRegistrationType {
  examRegistrationType: string;
}

const ValidatePaymentLink = () => {
  const appealRegistrationLabel = 'appeal-registration';
  const examRegistrationLabel = 'exam-registration';
  const amendmentRegistrationLabel = 'amendment-registration';

  const { t } = useTranslation();

  let title = 'Register Year-End MTL Exam';
  const { examRegistrationType } = useParams<ExamRegistrationType>();
  if (
    examRegistrationType === examRegistrationLabel ||
    examRegistrationType === amendmentRegistrationLabel
  ) {
    title = t('exam->>PaymentLink.ExamRegistrationPayment');
  }

  if (examRegistrationType === appealRegistrationLabel) {
    title = t('appeal->>AppealRoute.Appeal for Review of Results');
  }

  return (
    <>
      <TitleHeader title={title} />

      {examRegistrationType === 'resit' && (
        <ContentTemplate>
          <ResitPaymentLink />
        </ContentTemplate>
      )}

      {examRegistrationType === appealRegistrationLabel && <AppealPaymentLink />}

      {examRegistrationType === examRegistrationLabel && <ExamRegistrationPaymentLink />}

      {examRegistrationType === amendmentRegistrationLabel && <AmendmentPaymentLink />}
    </>
  );
};

export default ValidatePaymentLink;
